export const fileConstants = {
  FILE_UPLOAD_REQUEST: 'FILE_UPLOAD_REQUEST',
  FILE_UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS',
  FILE_UPLOAD_ERROR: 'FILE_UPLOAD_ERROR',
  FILE_DELETE_LOCAL_AT_INDEX: 'FILE_DELETE_LOCAL_AT_INDEX',
  FILE_DELETE_LOCAL_AT_INDEXES: 'FILE_DELETE_LOCAL_AT_INDEXES',
};
